"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workflow_designer_point_model_1 = require("./workflow-designer-point.model");
var workflow_designer_types_1 = require("./workflow-designer.types");
var WorkflowDesignerGizmoModel = /** @class */ (function () {
    function WorkflowDesignerGizmoModel() {
        this.type = workflow_designer_types_1.WorkflowDesignerType.GIZMO;
        this.stateRect = true;
        this.visible = false;
        this.start = new workflow_designer_point_model_1.WorkflowDesignerPointModel();
        this.end = new workflow_designer_point_model_1.WorkflowDesignerPointModel();
    }
    WorkflowDesignerGizmoModel.prototype.show = function () {
        this.visible = true;
    };
    WorkflowDesignerGizmoModel.prototype.hide = function () {
        this.visible = false;
    };
    Object.defineProperty(WorkflowDesignerGizmoModel.prototype, "points", {
        get: function () {
            return this.start.x + ',' + this.start.y + ',' + this.end.x + ',' + this.end.y;
        },
        enumerable: true,
        configurable: true
    });
    return WorkflowDesignerGizmoModel;
}());
exports.WorkflowDesignerGizmoModel = WorkflowDesignerGizmoModel;
//# sourceMappingURL=workflow-designer-gizmo.model.js.map